import { useState } from 'react'
import { Alert, Select, Switch, Input, Checkbox, Tooltip, Row, Col } from 'antd'
import AceEditor from 'react-ace'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { getTemplateInputs } from 'Services/ActionsPagesUtils'
import { configDataTypes } from './constants'
import { ActionsPage } from 'Model'

import 'ace-builds/src-noconflict/mode-c_cpp'
import 'ace-builds/src-noconflict/theme-github'

ConfigItem = ({ data, onChange, template, darkModeEnabled }) ->

  [isNotStatic, setIsNotStatic] = useState(data.value?[0] is '%')
  intialVal = "%#{getTemplateInputs(template)[0]}"

  <Row style={{ minWidth: '25vw' }}>
    <Col span={6}>
      <Switch
        disabled={data.name isnt 'file'}
        checkedChildren="User provided"
        unCheckedChildren="Static"
        checked={isNotStatic}
        onChange={(checked) ->
          setIsNotStatic(checked)
          onChange(data.value or intialVal)
        }
        style={{ marginTop: 5 }}
      />
    </Col>
    <Col span={18}>
      {
        if isNotStatic
          <Select
            options={getTemplateInputs(template)
              .map((key) ->
                { label: _.startCase(key), value: '%' + key }
              )
            }
            value={!_.isObject(data.value) && data.value}
            onChange={onChange}
          />
        else
          <StaticConfigInput
            type={data.type}
            value={data.value}
            name={data.name}
            onChange={onChange}
            darkModeEnabled={darkModeEnabled}
          />
      }
    </Col>
  </Row>

StaticConfigInput = ({ type, value, name, onChange, darkModeEnabled }) ->
  props = { value, onChange }

  switch type
    when configDataTypes.string
      <Input
        value={props.value}
        onChange={({ target: { value }}) -> props.onChange(value)}
      />
    when configDataTypes.file
      <Input value={props.value} onChange={({ target: { value }}) -> props.onChange(value)} />
    when configDataTypes.number
      <InputNumber {props...} />
    when configDataTypes.integer
      <InputNumber {props...} />
    when configDataTypes.boolean
      props.checked = props.value
      <Checkbox {props...} />
    when configDataTypes.array
      <Select mode="tags" {props...} />
    when configDataTypes.object
      <AceEditor
        defaultValue={JSON.stringify(props.value, null, 2)}
        onChange={(val) ->
          try
            props.onChange(JSON.parse(val))
        }
        height="100px"
        setOptions={{ readOnly: false }}
        mode="json"
        theme={darkModeEnabled && "solarized_dark" || "solarized_light"}
      />
    else
      <Alert message="Faulty configuration found. Contact an administrator for assistance." type="error" />

export default ConfigItem
